import {Box} from '@mui/material';
import {useEffect, useRef, useState} from 'react';
import ChartColumnMultiple from 'src/sections/_examples/extra/chart-view/chart-column-multiple';
import RCMDashboardTable from '../RCMDashboardTable';
import {fetchChartColors} from 'src/utils/chart_utils';

const OutstandingARComponent = ({data, chartData, ...props}: any) => {
  const [chartColors, setChartColors] = useState<any>({});
  const barChartRef = useRef<any>(null);
  const pieChartRef = useRef<any>(null);

  useEffect(() => {
    // Fetch colors after charts are rendered
    const refList: any = [
      {
        ref: barChartRef,
        type: 'bar',
        name: 'bar_chart_01'
      },
      {
        ref: pieChartRef,
        type: 'pie',
        name: 'pie_chart_01'
      }
    ];
    setTimeout(() => {
      /** Function to retrieve chart colors */
      fetchChartColors(setChartColors, refList);
    }, 500);
  }, [chartData]);

  return (
    <>
      <ChartColumnMultiple
        chartRef={barChartRef}
        chartOptionsObj={{
          yaxis: {
            labels: {
              formatter: function (value: any) {
                return `$${value}`; // Add the dollar symbol before the value
              }
            }
          },
          plotOptions: {bar: {columnWidth: '80%'}},
          ...chartData?.bar_chart_01
        }}
        series={chartData?.bar_chart_01?.series ?? []}
      />
      {chartColors?.bar_chart_01 ? (
        <Box sx={{mt: 5}}>
          <RCMDashboardTable
            data={{
              ...chartData?.table_data_01,
              colors: chartColors?.bar_chart_01
            }}
            valueFormatter={'currency'}
            addOnRows={['Grand Total', 'Percentage']}
          />
          <div style={{margin: '60px'}}></div>
          <RCMDashboardTable
            data={{
              ...chartData?.table_data_02,
              colors: chartColors?.bar_chart_01
            }}
          />
        </Box>
      ) : null}
    </>
  );
};

export default OutstandingARComponent;
